<div class="container m-b-20 layout-row align-end gap-20px">
  <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_REPORT'">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>

  @if (!reportData.coreReport) {
    <span>
      <button mat-raised-button color="warn" (click)="delete()" *LOSxHasPermission="'DELETE_REPORT'">
        <fa-icon icon="trash" class="m-r-10"></fa-icon>
        {{ 'labels.buttons.Delete' | translate }}
      </button>
    </span>
  }
</div>

<div class="container">
  <mat-card>
    <mat-card-title class="layout-row-wrap flex-100">
      <div class="flex-100 report-name">
        {{ 'labels.catalogs.Report' | translate }} : <b>{{ reportData.reportName }}</b>
      </div>
    </mat-card-title>

    <mat-card-content>
      <div class="layout-row-wrap">
        <div class="flex-50 mat-body-strong">{{ 'labels.inputs.Report Type' | translate }}:</div>

        <div class="flex-50">
          {{ reportData.reportType | translateKey: 'text' }}
        </div>

        @if (reportData.reportSubType) {
          <div class="mat-body-strong flex-50">{{ 'labels.inputs.Report Sub Type' | translate }}:</div>
        }

        @if (reportData.reportSubType) {
          <div class="flex-50">
            {{ reportData.reportSubType | translateKey: 'text' }}
          </div>
        }

        <div class="flex-50 mat-body-strong">{{ 'labels.inputs.Report Category' | translate }}:</div>

        <div class="flex-50">
          {{ reportData.reportCategory | translateKey: 'catalogs' }}
        </div>

        <div class="flex-50 mat-body-strong">{{ 'labels.inputs.Core Report' | translate }}:</div>

        <div class="flex-50">
          {{ reportData.coreReport | yesNo }}
        </div>

        <div class="flex-50 mat-body-strong">{{ 'labels.inputs.User Report' | translate }}:</div>

        <div class="flex-50">
          {{ reportData.useReport | yesNo }}
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
